import React from 'react'
import { InfoList, InfoListWrapper } from './MyProfilePageStyled'
import { inject, observer } from 'mobx-react'
import { EmptyText } from '../../components/Common/CellText'

const Health = props => {
  const { authenticationStore } = props

  const { currentUser } = authenticationStore
  const nullText = <EmptyText>Chưa cập nhật</EmptyText>

  return (
    <InfoListWrapper>
      <InfoList>
        <dt>Tình trạng sức khỏe</dt>
        <dd>{currentUser?.other?.health_status || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Chiều cao</dt>
        <dd>{currentUser?.other?.height || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Cân nặng</dt>
        <dd>{currentUser?.other?.weight || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Nhóm máu</dt>
        <dd>{currentUser?.other?.blood_types || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Là thương binh hạng</dt>
        <dd>{currentUser?.other?.wounded_soldier_class || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Là con gia đình chính sách</dt>
        <dd>{currentUser?.other?.child_policy_family || nullText}</dd>
      </InfoList>
    </InfoListWrapper>
  )
}

Health.propTypes = {}

export default inject('authenticationStore')(observer(Health))
